import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SidebarCloseIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 12" fill="none" {...props}>
    <Path
      d="M10 3.96484C9.9994 3.60904 9.5692 3.43105 9.3174 3.68262L7.2832 5.7168C7.1271 5.87295 7.1272 6.126 7.2832 6.28223L9.3174 8.31641C9.5693 8.56831 9.9997 8.39032 10 8.03418V6.75H12.5996C12.8205 6.75 13 6.57049 13 6.34961V5.64941C12.9998 5.42871 12.8204 5.25 12.5996 5.25H10V3.96484Z"
      fill="currentColor"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 0C14.6569 0 16 1.34315 16 3V9C16 10.6569 14.6569 12 13 12H3L2.8457 11.9961C1.26055 11.9158 0 10.6051 0 9V3C0 1.34315 1.34315 0 3 0H13ZM3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V9C1.5 9.82843 2.17157 10.5 3 10.5H4.25V1.5H3ZM5.75 10.5H13C13.8284 10.5 14.5 9.82843 14.5 9V3C14.5 2.17157 13.8284 1.5 13 1.5H5.75V10.5Z"
      fill="currentColor"
    />
  </Icon>
);
